<template>
  <div class="form-wrap">
    <h1 class="blog-post-title-2">
      Speak To An Expert
    </h1>
    <form
      id="freeDemo" method="post"
      @submit="handleFreeDemoFormSubmit"
    >
      <div class="row">
        <div class="input-group col-6 sm-6 col first-name">
          <label for="name" class="required">First Name</label>
          <input
            id="Firstname" v-model="firstName" type="text"
            name="first-name"
            autocomplete="first-name"
            placeholder="Enter first name"
            :class="{ 'invalid-field': firstNameAlert }"
            @input="firstNameAlert = ''"
          >
          <small v-if="firstNameAlert" class="alert">{{ firstNameAlert }}</small>
        </div>
        <div class="input-group col-6 sm-6 col last-name">
          <label for="name">Last name</label>
          <input
            id="lastName" v-model="lastName" type="text"
            name="last-name"
            autocomplete="last-name"
            placeholder="Enter last name"
          >
        </div>
        <div class="input-group col-12 col">
          <label for="name" class="required">Work Email</label>
          <input
            id="signup-email"
            v-model="email"
            type="text"
            name="signup-email"
            autocomplete="email"
            placeholder="name@company.com"
            :class="{ 'invalid-field': emailAlert }"
            @input="emailAlert = ''"
          >
          <small v-if="emailAlert" class="alert">{{ emailAlert }}</small>
        </div>
        <div class="input-group col-12 col">
          <label for="name">Company Name</label>
          <input
            id="signup-email"
            v-model="companyName"
            type="text"
            name="signup-email"
            autocomplete="email"
            placeholder="Enter your company name"
          >
        </div>
        <div class="input-group col-12 col">
          <label for="name">Number of Employees</label>
          <select v-model="employees" :class="{ selected: employees }">
            <option disabled value="">
              Select number of employees
            </option>
            <option
              v-for="(range,i) in numberOfEmployees"
              :key="i"
            >
              {{ range }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12">
        <button
          class="btn-primary btn-lg submit h6 col-12"
          type="submit"
        >
          {{ $c.text('component.freedemoform.button') }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      employees: '',
      numberOfEmployees: [
        '5-10',
        '11-20',
        '21-50',
        '51-100',
        '101-500',
        '501-1000',
        '1000+',
      ],
      firstNameAlert: '',
      emailAlert: '',
    };
  },
  mounted() {

  },
  methods: {
    onRecaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
    async handleFreeDemoFormSubmit(e) {
      e.preventDefault();
      const {
        firstName, lastName, email, companyName, employees,
      } = this;

      try {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!this.email || !re.test(this.email)) {
          this.emailAlert = 'Invalid email';
        }

        if (!this.firstName) {
          this.firstNameAlert = 'Required field';
        }

        if (!this.emailAlert && !this.firstNameAlert) {
          await this.$axios.$post('/feedback/free-demo-request', {
            firstName, lastName, email, companyName, employees,
          });

          await this.$store.dispatch('modals/open', {
            name: 'default',
            title: 'Thank you!',
            message: 'Your inquiry has been sent!',
          });

          dataLayer.push({ event: 'RequestDemo' });

          this.firstName = '';
          this.lastName = '';
          this.email = '';
          this.companyName = '';
          this.employees = '';
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.form-wrap {
  background-color: var(--main-light);
  border-radius: 10px;
  color: var(--main-dark-shade-0);
  padding: 42px var(--spacing-48) var(--spacing-56);
  max-width: 570px;
  width: 100%;
  margin: auto;

  label {
    font-size: 14px;
    line-height: 120%;
    margin-bottom: 6px;
    display: inline-block;

    &.required:after {
      margin-left: 3px;
    }
  }

  .alert {
    position: absolute;
    bottom: 6px;
    color: var(--main-red);
  }

  .invalid-field {
    border-color: var(--main-red);
  }

  input,
  select {
    margin-bottom: var(--spacing-24);
  }

  select {
    color: var(--main-dark-light-4);

    option {
      color: var(--main-dark-shade-0);

      &:first-of-type {
        display: none;
      }
    }

    &.selected {
      color: var(--main-dark-shade-0);
    }
  }

  .blog-post-title-2 {
    margin-bottom: var(--spacing-50);
    text-align: center;
  }

  form .row {
    margin: 0 -12px;
  }

  .col {
    padding: 0 var(--spacing-12);
  }

  button {
    margin: var(--spacing-26) auto 0;
    display: table;
    width: 100%;
    max-width: 350px;
  }

  .btn-trial {
    color: var(--main-light-shade-4);
    display: block;
    text-align: center;
    font-size: 18px;
  }

  @include bp($bp-mobile) {
    margin-bottom: var(--spacing-80);
  }

  @include bp($bp-phone) {
    background-color: transparent;
    color: var(--main-light);
    margin-bottom: 0;
    padding: var(--spacing-80) 0 var(--spacing-160);

    .blog-post-title-2 {
      margin-bottom: var(--spacing-48);
    }

    input,
    select {
      background: transparent;
      border: 1px solid var(--main-dark-light-3);
      color: var(--main-light);

      option {
        color: var(--main-dark-shade-0);
      }

      /* Chrome/Opera/Safari */
      &::-webkit-input-placeholder {
        color: var(--main-dark-light-4);
      }

      /* Firefox 19+ */
      &::-moz-placeholder {
        color: var(--main-dark-light-4);
      }

      /* IE 10+ */
      &:-ms-input-placeholder {
        color: var(--main-dark-light-4);
      }

      /* Firefox 18- */
      &:-moz-placeholder {
        color: var(--main-dark-light-4);
      }

      &:focus {
        border-color: var(--main-light-shade-4);
      }

      &.selected {
        color: var(--main-light);
      }
    }

    input {
      color: var(--main-light);
    }

    select {
      background: transparent url('../assets/svg/arrow-down-b2b-sales.svg') no-repeat calc(100% - 20px) center;
    }
  }
}

@include bp($bp-laptop) {
  .form-wrap button {
    max-width: 310px;
  }

  .form-wrap .blog-post-title-2 {
    font-size: 24px;
  }
}

.fa {
  form#freeDemo {
    input,
    select {
      background-color: var(--main-light-shade-1);

      &::-webkit-input-placeholder,
      &::-moz-placeholder,
      &:-ms-input-placeholder,
      &:-moz-placeholder,
      &::placeholder {
        color: var(--main-dark-shade-0);
      }

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 50px var(--main-light) inset !important;
        -webkit-text-fill-color: var(--black) !important;
      }
    }
  }

  @include bp($bp-phone) {
    form#freeDemo {
      input,
      select {
        background-color: transparent;

        &:-webkit-autofill {
          -webkit-box-shadow: 0 0 0 50px var(--main-dark-light-1) inset !important;
          -webkit-text-fill-color: var(--main-light) !important;
        }
      }
    }
  }
}
</style>
